import * as React from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, Typography } from '@mui/material';

const setPreview = (file, setPhoto, onChange, watermark) => {
  const reader = new FileReader();
  reader.readAsArrayBuffer(file);
  reader.onload = (event) => {
    const blob = new Blob([event.target.result]);
    const blobURL = window.URL.createObjectURL(blob);
    const image = new Image();
    image.src = blobURL;
    image.onload = () => {
      const canvas = document.createElement('canvas');

      const width = image.width;
      const height = image.height;

      const compressPercent = Number(
        Math.round(1024 / Math.max(width, height) + 'e+2') + 'e-2'
      );

      canvas.width = width * compressPercent;
      canvas.height = height * compressPercent;

      const ctx = canvas.getContext('2d');
      ctx.drawImage(
        image,
        0,
        0,
        width * compressPercent,
        height * compressPercent
      );

      if (watermark) {
        const watermarkCanvas = document.createElement('canvas');
        const watermarkCtx = watermarkCanvas.getContext('2d');
        const w = (watermarkCanvas.width = canvas.width);
        const h = (watermarkCanvas.height = canvas.height);
        watermarkCtx.drawImage(canvas, 0, 0);
        watermarkCtx.font = 'bolder 72px PingFang TC';
        watermarkCtx.fillStyle = 'rgba(255, 0, 0, 0.3)';
        const textWidth = watermarkCtx.measureText(watermark).width;
        watermarkCtx.fillText(watermark, (w - textWidth) / 2, h / 2 + 36);
        watermarkCtx.lineWidth = 6;
        watermarkCtx.strokeStyle = 'rgba(255, 0, 0, 0.3)';
        watermarkCtx.strokeRect(
          (w - textWidth - 8) / 2,
          h / 2 - 29,
          textWidth + 8,
          80
        );

        if (setPhoto) {
          setPhoto(watermarkCanvas.toDataURL('image/jpeg', 0.8));
        }

        if (onChange) {
          onChange(watermarkCanvas.toDataURL('image/jpeg', 0.8));
        }
      } else {
        if (setPhoto) {
          setPhoto(canvas.toDataURL('image/jpeg', 0.8));
        }

        if (onChange) {
          onChange(canvas.toDataURL('image/jpeg', 0.8));
        }
      }
    };
  };
};

const PhotoField = ({ label, placeholder, capture, onChange, watermark }) => {
  const [photo, setPhoto] = React.useState('');
  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    noKeyboard: true,
    noDrag: true,
    maxFiles: 1,
    useFsAccessApi: false,
    accept: {
      'image/*': [],
    },
    onDrop: (acceptedFiles) => {
      setPreview(acceptedFiles[0], setPhoto, onChange, watermark);
    },
  });

  return (
    <Box>
      {photo ? (
        <Typography variant="h6" sx={{ mb: 1, textAlign: 'left' }}>
          {label}：
        </Typography>
      ) : null}
      <Box
        {...getRootProps()}
        sx={(theme) => ({
          mb: 3,
          minHeight: 150,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          borderWidth: 1,
          borderRadius: 2,
          borderColor: 'rgba(0,0,0,0.23)',
          borderStyle: 'dashed',
          backgroundColor: theme.palette.grey[50],
          color: theme.palette.text.secondary,
          fontSize: 16,
          overflow: 'hidden',
          outline: 'none',
          transition: 'border 0.24s ease-in-out',
          '&:focus': {
            borderColor: theme.palette.primary.main,
          },
          '&.disable': {
            opacity: 0.6,
          },
        })}
      >
        <input {...getInputProps()} capture="environment" />
        {photo ? (
          <img style={{ width: '100%' }} src={photo} alt="alt" />
        ) : placeholder ? (
          placeholder
        ) : null}
      </Box>
    </Box>
  );
};

export default PhotoField;
